import request from '@/api/axios'
import { apiList as api } from './apiList'
import { getStore } from '@/util/store'
import { DatePickerPanel, MessagePlugin } from 'tdesign-vue-next'
import WujieVue from 'wujie-vue3'
const { bus } = WujieVue

// 获取是否有活动应用权限
export function getActivityAuth() {
  return request({
    url: api.indexBeiDiscuss.getActivityAuth,
    method: 'get',
  })
}

// 查询用户是否在教研中
export function activeDiscussTask() {
  const userId = getStore({ name: 'userInfo' })?.id
  return request({
    url: api.indexBeiDiscuss.activeDiscussTask + `${userId}/3`,
    method: 'get',
  })
}

// 查询用户是否在教研中
function getIsInDiscuss(discussId) {
  const userId = getStore({ name: 'userInfo' })?.id
  return request({
    url: api.indexBeiDiscuss.getIsInDiscuss + `${discussId}/${userId}`,
    method: 'get',
  })
}

// 检查权限
export const isInDiscuss = (discussId) => {
  return new Promise((resolve) => {
    getIsInDiscuss(discussId).then((res) => {
      if (res.data.data === true) {
        resolve(true)
      } else {
        resolve(false)
      }
    })
  })
}

// 记录研训操作
export async function operationRecord(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.operationRecord,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 研训基本信息
export async function getDiscussBasic(discussId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getDiscussBasic + discussId,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 研训基本信息
export async function getDiscussUsers(discussId, userId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getDiscussUsers + `${discussId}/${userId}`,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 添加公告
export async function addNotice(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addNotice,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 公告列表
export async function getNoticeList(discussId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getNoticeList + discussId,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 获取最近一个公告
export async function getRecentNotice(discussId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getRecentNotice + discussId,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 获取最近一个公告
export async function deleteNotice(discussId, noticeId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.deleteNotice + noticeId,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 添加资料
export async function addResource(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addResource,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
  }
}

// 资料列表
export async function getResourceList(discussId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getResourceList + discussId,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 删除资料
export async function deleteResource(discussId, resourceId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.deleteResource + resourceId,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 获取关联学程列表
export async function getContactCourse(discussId, data) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getContactCourse,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 复制学程
export async function courseCopy(discussId, courseId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.courseCopy,
      method: 'get',
      params: { courseId },
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 课程列表
export async function getLessonList(discussId, userId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getLessonList + `${discussId}/${userId}`,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 保存课程视频观看进度
export async function saveLessonVideoProgress(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.saveLessonVideoProgress,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 添加课程目录
export async function addLessonCatalog(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addLessonCatalog,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 更改课程目录、视频标题
export async function editLessonTitle(discussId, data) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.editLessonTitle,
      method: 'put',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 删除课程目录、视频
export async function deleteLesson(discussId, id) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.deleteLesson + id,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 上传课程视频
export async function addLessonVideo(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addLessonVideo,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 拖拽课程视频顺序
export async function dragLessonVideo(discussId, ids) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.dragLessonVideo,
      method: 'put',
      data: ids,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 获取会议/直播列表
export async function getMeetingList(discussId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getMeetingList + discussId,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 获取会议/直播列表
export async function delMeeting(discussId, id) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delMeeting + id,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 校验会议地址
export async function checkMeetingUrl(discussId, params) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.checkMeetingUrl,
      method: 'get',
      params,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 添加会议/直播
export async function addMeeting(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addMeeting,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 成果列表
export async function getResultList(discussId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getResultList + discussId,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 上传成果
export async function addResult(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addResult,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 删除成果
export async function delResult(discussId, id) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delResult + id,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 生成画布元素唯一ID
export async function getCanvasDrawId() {
  return request({
    url: api.indexBeiDiscuss.getCanvasDrawId,
    method: 'get',
  })
}

// 获取白板数据
export async function getBoard(discussId, userId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getBoard + `${discussId}/${userId}`,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 新增/保存白板数据
export async function addEditBoard(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addEditBoard,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 删除白板
export async function delBoard(discussId, id) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delBoard + id,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-获取文件列表
export async function getResearchFile(discussId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getResearchFile + discussId,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-删除文件
export async function delResearchFile(discussId, id) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delResearchFile + id,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-上传文件
export async function addResearchFile(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addResearchFile,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-获取画布对象
export async function getFileCanvas(params) {
  const { discussId, documentId, documentItemId, viewerId } = params
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getFileCanvas + `${discussId}/${documentId}/${documentItemId}/${viewerId}`,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-添加/编辑画布元素
export async function addEditFileDraw(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addEditFileDraw,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-删除画布元素
export async function removeFileDraw(discussId, drawId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.removeFileDraw + drawId,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-添加批注
export async function addFileAnnocation(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addFileAnnocation,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-删除批注
export async function delFileAnnocation(discussId, id) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delFileAnnocation + id,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-获取批注列表
export async function getFileAnnocation(params) {
  const { discussId, documentId, documentItemId, pointId } = params
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getFileAnnocation + `${documentId}/${documentItemId}/${pointId}`,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 文件研究-删除批注列表
export async function delFileAnnocationList(params) {
  const { discussId, documentId, documentItemId, pointId } = params
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delFileAnnocationList + `${documentId}/${documentItemId}/${pointId}`,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-添加批注
export async function addCourseAnnocation(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addCourseAnnocation,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-删除批注
export async function delCourseAnnocation(discussId, id) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delCourseAnnocation + id,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-获取批注列表
export async function getCourseAnnocation(params) {
  const { discussId, pointId } = params
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getCourseAnnocation + `${pointId}`,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-删除批注列表
export async function delCourseAnnocationList(params) {
  const { discussId, documentId, documentItemId, pointId } = params
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delCourseAnnocationList + `${documentId}/${documentItemId}/${pointId}`,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 演示模式学程详情
export function demoCourseDetail(courseId) {
  return request({
    url: api.indexBeiDiscuss.demoCourseDetail + courseId,
    method: 'get',
  })
}

// 学程研究-学程列表
export async function getCourseResearch(discussId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getCourseResearch + discussId,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-学程列表
export async function delResearchCourse(discussId, id) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.delResearchCourse + id,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-学程列表
export async function addResearchCourse(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addResearchCourse,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-获取画布对象
export async function getCourseCanvas(params) {
  const { discussId, courseResearchId, viewerId } = params
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.getCourseCanvas + `${discussId}/${courseResearchId}/${viewerId}`,
      method: 'get',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-添加/编辑画布元素
export async function addEditCourseDraw(data) {
  const hasAuth = await isInDiscuss(data?.discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.addEditCourseDraw,
      method: 'post',
      data,
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 学程研究-删除画布元素
export async function removeCourseDraw(discussId, drawId) {
  const hasAuth = await isInDiscuss(discussId)
  if (hasAuth) {
    return request({
      url: api.indexBeiDiscuss.removeCourseDraw + drawId,
      method: 'delete',
    })
  } else {
    MessagePlugin.warning('你已不在本次活动范围内！')
    bus.$emit('index-bei-discuss-reload')
    return false
  }
}

// 获取字典项
export function getDictItem(code) {
  return request({
    url: api.indexBeiDiscuss.getDictItem + code,
    method: 'get',
  })
}

// 获取教材
export function getTutorial(data) {
  return request({
    url: api.indexBeiDiscuss.getTutorial,
    method: 'post',
    data,
  })
}

// 获取教材
export function getUnit(tutorialId) {
  return request({
    url: api.indexBeiDiscuss.getUnit + tutorialId,
    method: 'get',
  })
}

// 复制学程
export function copyCourse(courseId) {
  return request({
    url: api.indexBeiDiscuss.copyCourse,
    method: 'get',
    params: { courseId },
  })
}

// 修改学程属性
export function editCourse(data) {
  return request({
    url: api.indexBeiDiscuss.editCourse,
    method: 'put',
    data,
  })
}
